'use strict';
import Cache from 'js-cache';

export const ACL_UPDATE_TTL = 5 * 60 * 1000;
export const orgAclUpdatesCache = new Cache();
export const projectAclUpdatesCache = new Cache();
export const taskAclUpdatesCache = new Cache();
export const assetTaskAclUpdatesCache = new Cache();



// WEBPACK FOOTER //
// ./src/js/auth/services/PermissionsConfig.js